import React, { useState } from "react";
import "./IconicGalleryImages.css";
import AboutBanner from "../AboutUs/AboutBanner";
import { useParams, useNavigate } from "react-router-dom";

/* =========================================================
   FURNITURE IMAGES
========================================================= */

import img1 from "../../assets/products/Furniture/6BOeWN4bBXsL0sSlfmS3uG5zGwA5FLLLo1Pv1LP0.jpg";
import img2 from "../../assets/products/Furniture/7PqbHJc9Uhz1MPejlVRdBz4WRj93qUQo1Iyyh5dN.jpg";
import img3 from "../../assets/products/Furniture/9VQsSwJtRaXSeTbYZQ19w9KW6zI24dstUVVL46N9.jpg";
import img4 from "../../assets/products/Furniture/367QXEbgBoB7X5WZF6CaxVmI8f1pQFXZp9FlRfMW.jpg";
import img5 from "../../assets/products/Furniture/asf7ecvGhjhVI2KiCvFGzTFChyIcdLB5rHNI4v9P.jpg";
import img6 from "../../assets/products/Furniture/AToQ2F1MdBsDfmOSgcWDQuuep42ClB7DeCxpyOKX.webp";
import img7 from "../../assets/products/Furniture/bq2j4Vj5OqwvaHcxRPnDqee4bJpFAxHtsRwDGmGL.jpg";
import img8 from "../../assets/products/Furniture/c5xXpEifWzoS8szx8RMZ6ShMi4rIxHIhgwDKU3pC.jpg";
import img9 from "../../assets/products/Furniture/CoFKWJWlNeOQPXRxYJKgQL8XO53QqkqK2YCdveEl.jpg";
import img10 from "../../assets/products/Furniture/dyoKjugH3bBAMxViX7ZwWWcEt6E8OHkz1UIS6Aga.jpg";
import img11 from "../../assets/products/Furniture/EcbXi0sDNKSGCScvwNexbUbxLQUnGhBXkCYlSUaY.webp";
import img12 from "../../assets/products/Furniture/FA5C65Vj1azjGHWqxOsifLZwS5zxoNj8PEG90ipv.jpg";
import img13 from "../../assets/products/Furniture/FAQbiBErfkAsy7vLqkrtvUxkQTTam3jcUuuwOqKP.webp";
import img14 from "../../assets/products/Furniture/j1ZbKpRX0efNBGP2FlJJHgJhxDUVNvJxh5c5KKP9.jpg";
import img15 from "../../assets/products/Furniture/qICpZww4ddxITVpDBzIeEKGHVaUJgSeIWuhBAbo8.webp";
import img16 from "../../assets/products/Furniture/0FMZoi8gFfaLUiYxtuXhHqplv2ORH2ALK9fuapMB.jpg";
import img17 from "../../assets/products/Furniture/aKuFkTuGIQmPvCGuXfgsu1CKrEaAKtoxcIwtdGbc.jpg";
import img18 from "../../assets/products/Furniture/jn8EhVq8Ru2bXLAOXkTDj582Y3j52VeGGRHzQN2W.jpg";
import img19 from "../../assets/products/Furniture/kFvIG2i45Si7fm6Nl3T60P4aqQI7k2O3YoBbjMEy.jpg";
import img20 from "../../assets/products/Furniture/LM4sBNHhKy4zRyiZdVYxl3OJPrjs8WjqDsCc9NUJ.jpg";
import img21 from "../../assets/products/Furniture/NGABOWvDKcuqiQFvHFogIMgVxbjdZWWJ62pl2Sig.jpg";
import img22 from "../../assets/products/Furniture/nXQ4rC9gmh6j6OGsZ0aUg5M7FF5VyC5zbkTcKBUp.jpg";
import img23 from "../../assets/products/Furniture/od2ThmghE7rRLAe4Qe1luNWmVHrICDjO7q86CUCw.jpg";
import img24 from "../../assets/products/Furniture/OeCgDJG1yUgRoDI8wH8rSnSyJQKgnzRezmQ2qwRL.webp";
import img25 from "../../assets/products/Furniture/oMjXo2Etg7K2bn5OuD4jvGE4OcalxM9FtMsMJEqD.webp";
import img26 from "../../assets/products/Furniture/QE5ch7JI2cOuPm20Jdgqmkg4iRkHX7JcBc8bLWxT.webp";
import img27 from "../../assets/products/Furniture/qIwyBYsK44XPbgkGnjNV8RXq1G1NequLIbtPgoJT.jpg";
import img28 from "../../assets/products/Furniture/RUBLt7YDnfXKSfW6Fd7QU6YMyUlMpNg4OAGVGTWy.jpg";
import img29 from "../../assets/products/Furniture/s5LUDgU9DrRVobJjujx9Pje4OgBbZcQceX1j1dRG.webp";
import img30 from "../../assets/products/Furniture/UBQDjp6OWJW0lPHCByiQ3qFFbwFVbfy9giv4ZNyP.jpg";
import img31 from "../../assets/products/Furniture/uHqLbzZA5sayNwSdXDRCFijP7rz5RTpmCtyt8p1Z.jpg";
import img32 from "../../assets/products/Furniture/wAKDfXbqDkyzpvRK7FFJF0KxGypTbTy30PWIEeXD.jpg";
import img33 from "../../assets/products/Furniture/xAQoWqzDX3VYaFhCRueDeW4JEMOTaXE6wEA1bhYo.jpg";
import img34 from "../../assets/products/Furniture/YReshThoFyFr0qmPZ8ny7LQOSS9xrSO6qsJcdfLh.webp";
import img35 from "../../assets/products/Furniture/zfggdgjmB24pQeml9V6jxG0HWw2ny1fBRorsbfwp.webp";

/* =========================================================
   SUPER SHOP IMAGES
========================================================= */

import img36 from "../../assets/products/supershop/fresh_milk.jpg";
import img37 from "../../assets/products/supershop/potato-regular.webp";
import img38 from "../../assets/products/supershop/rice.jfif";
import img39 from "../../assets/products/supershop/olympic-premium-toast.jfif";
import img40 from "../../assets/products/supershop/small-3-7-kg-diapers.jfif";
import img41 from "../../assets/products/supershop/OIP.jfif";
import img42 from "../../assets/products/supershop/egg.jfif";
import img43 from "../../assets/products/supershop/kichen_nuggets.webp";
import img44 from "../../assets/products/supershop/pran_soyabin.jpg";

/* =========================================================
   ICONIC SHIKHON IMAGES
========================================================= */

import img45 from "../../assets/products/iconic_shikhon/A4_bosundora_paper.jpg";
import img46 from "../../assets/products/iconic_shikhon/heavy-duty-staplers.jpg";
import img47 from "../../assets/products/iconic_shikhon/matardo_pinPoint.jpg";
import img48 from "../../assets/products/iconic_shikhon/pexels-kindelmedia.jpg";

/* =========================================================
   ICONIC GREENLAND IMAGES
========================================================= */

import img49 from "../../assets/greenland-image/blog_img_01.jpeg";
import img50 from "../../assets/greenland-image/blog_img_02.jpeg";
import img51 from "../../assets/greenland-image/blog_img_03.jpeg";
import img52 from "../../assets/greenland-image/blog_img_04.jpeg";
import img53 from "../../assets/greenland-image/blog_img_05.jpeg";
import img54 from "../../assets/greenland-image/blog_img_06.jpeg";
import img55 from "../../assets/greenland-image/blog_img_07.jpeg";
import img56 from "../../assets/greenland-image/blog_img_09.jpeg";
import img57 from "../../assets/greenland-image/iconic and bulders.jpeg";
import img58 from "../../assets/greenland-image/galary1.jpeg";
import img59 from "../../assets/greenland-image/blog_img_02.jpeg";
import img60 from "../../assets/greenland-image/galary5.jpeg";

/* =========================================================
   ICONIC MOTORS IMAGES
========================================================= */

import img61 from "../../assets/motors_images/busbody.webp";
import img62 from "../../assets/motors_images/bus2.jpg";
import img63 from "../../assets/motors_images/bus3.jfif";
import img64 from "../../assets/motors_images/busbody.webp";
import img65 from "../../assets/motors_images/express.png";
import img66 from "../../assets/motors_images/luxary.jpg";
import img67 from "../../assets/motors_images/polish.jpg";
import img68 from "../../assets/motors_images/showroom.jpg";

/* =========================================================
   ICONIC HAJJ IMAGES
========================================================= */

import img69 from "../../assets/hajj_images/hajj1.jpg";
import img70 from "../../assets/hajj_images/hajj2.jpg";
import img71 from "../../assets/hajj_images/hajj3.jpg";
import img72 from "../../assets/hajj_images/hajj4.jpg";
import img73 from "../../assets/hajj_images/hajj5.jpg";
import img74 from "../../assets/hajj_images/hajj6.jpg";
import img75 from "../../assets/hajj_images/hajj7.jpg";
import img76 from "../../assets/hajj_images/hajj8.jpg";
import img77 from "../../assets/hajj_images/hajj9.jpg";
import img78 from "../../assets/hajj_images/hajj10.jpg";
import img79 from "../../assets/hajj_images/hajj12.jpg";
import img80 from "../../assets/hajj_images/hajj13.jpg";

/* =========================================================
   COMPONENT
========================================================= */

const IconicGalleryImages = () => {
  const { company } = useParams();
  const navigate = useNavigate();

  const [activePhoto, setActivePhoto] = useState(null);

  /* =========================================================
     COMPANY GALLERY DATA
  ========================================================= */

  const companyGalleryData = {
    /* -------------------------------------------------------
       GREENLAND
    ------------------------------------------------------- */

    greenland: {
      title: "ICONIC GREENLAND",
      description:
        "Explore our real estate projects, properties and development journey.",

      images: [
        img49,
        img50,
        img51,
        img52,
        img53,
        img54,
        img55,
        img56,
        img57,
        img58,
        img59,
        img60,
      ],
    },

    /* -------------------------------------------------------
       SUPER SHOP
    ------------------------------------------------------- */

    supershop: {
      title: "ICONIC SUPER SHOP",
      description:
        "Explore our products, collections and shopping experiences.",

      images: [img36, img37, img38, img39, img40, img41, img42, img43, img44],
    },

    /* -------------------------------------------------------
       SHIKHON
    ------------------------------------------------------- */

    shikhon: {
      title: "ICONIC SHIKHON",
      description:
        "Explore our educational products, learning materials and experiences.",

      images: [img45, img46, img47, img48],
    },

    /* -------------------------------------------------------
       FURNITURE
    ------------------------------------------------------- */

    furniture: {
      title: "ICONIC FURNITURE",
      description:
        "Explore our furniture collections, products and creative designs.",

      images: [
        img1,
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18,
        img19,
        img20,
        img21,
        img22,
        img23,
        img24,
        img25,
        img26,
        img27,
        img28,
        img29,
        img30,
        img31,
        img32,
        img33,
        img34,
        img35,
      ],
    },

    /* -------------------------------------------------------
       HAJJ
    ------------------------------------------------------- */

    hajj: {
      title: "ICONIC HAJJ",
      description:
        "Explore our Hajj and Umrah journey highlights and experiences.",

      images: [
        img69,
        img70,
        img71,
        img72,
        img73,
        img74,
        img75,
        img76,
        img77,
        img78,
        img79,
        img80,
      ],
    },

    /* -------------------------------------------------------
       MOTORS
    ------------------------------------------------------- */

    motors: {
      title: "ICONIC MOTORS",
      description: "Explore our automotive collection, vehicles and services.",

      images: [img61, img62, img63, img64, img65, img66, img67, img68],
    },
  };

  /* =========================================================
     CURRENT COMPANY
  ========================================================= */

  const currentCompany = companyGalleryData[company];

  /* =========================================================
     INVALID COMPANY
  ========================================================= */

  if (!currentCompany) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: "20px",
          padding: "40px 20px",
          textAlign: "center",
        }}
      >
        <h2>Gallery Not Found</h2>

        <p style={{ color: "#777" }}>
          The requested company gallery does not exist.
        </p>

        <button
          type="button"
          onClick={() => navigate("/gallery")}
          style={{
            border: "1px solid #bd06d3",
            background: "#bd06d3",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 600,
          }}
        >
          Back to Gallery
        </button>
      </div>
    );
  }

  /* =========================================================
     CREATE GALLERY IMAGE OBJECTS
  ========================================================= */

  const galleryImages = currentCompany.images.map((src, index) => ({
    id: index + 1,
    src,
    alt: `${currentCompany.title} Gallery ${index + 1}`,
  }));

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div className="ga-gallery-container">
      {/* =====================================================
          BANNER
      ===================================================== */}

      <AboutBanner
        text={currentCompany.title}
        des={currentCompany.description}
      />

      {/* =====================================================
          PHOTO GALLERY
      ===================================================== */}

      <section className="ga-photo-gallery-section">
        <div className="ga-photo-gallery-container">
          <h2 className="ga-photo-gallery-title">
            {currentCompany.title}{" "}
            <span style={{ color: "#bd06d3" }}>PHOTO GALLERY</span>
          </h2>

          {galleryImages.length > 0 ? (
            <div className="ga-photo-gallery-grid">
              {galleryImages.map((img) => (
                <div
                  key={img.id}
                  className="ga-photo-card"
                  onClick={() => setActivePhoto(img.src)}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="ga-photo-img"
                    loading="lazy"
                  />

                  <div className="ga-photo-overlay">
                    <span>View Image</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "80px 20px",
              }}
            >
              <h3>Gallery Images Coming Soon</h3>

              <p
                style={{
                  marginTop: "10px",
                  color: "#777",
                }}
              >
                We are preparing the photo gallery for {currentCompany.title}.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* =====================================================
          IMAGE MODAL
      ===================================================== */}

      {activePhoto && (
        <div
          className="ga-photo-modal-overlay"
          onClick={() => setActivePhoto(null)}
        >
          <div
            className="ga-photo-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="ga-photo-modal-close"
              onClick={() => setActivePhoto(null)}
              aria-label="Close image"
            >
              &times;
            </button>

            <img
              src={activePhoto}
              alt="Gallery Preview"
              className="ga-photo-modal-img"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default IconicGalleryImages;
